/* eslint-disable object-curly-newline */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import TitleBar from './components/TitleBar';
import InfoPanel from './components/InfoPanel';
import {
  GET_REPORT_FAILURE,
  GET_REPORT_REQUEST,
  GET_REPORT_SUCCESS,
  getReport,
} from './actions/sc5Report';
import LoadingScreen from './components/LoadingScreen';
import { SC5ReportEntity } from './reducers/entities/sc5Report';
import 'react-virtualized/styles.css';
import { getNameByPixels } from './modules/BreakpointService';
import { ReportPanel } from './components/ReportPanel';

export const App = (): JSX.Element => {
  const {
    data: bgeReport,
    errorMessage: sc5ApiError,
    status: sc5ReportStatus,
  } = useSelector((state: any): SC5ReportEntity => (
    state.entities.sc5Report
  ));

  const sc5Report = bgeReport && bgeReport.sc5Report;

  const dispatch = useDispatch();
  useEffect((): void => {
    dispatch(getReport({}));
  }, [dispatch]);

  const [deviceType, setDeviceType] = useState('desktop');

  const onResize = _.debounce((): void => {
    const appDOMContainer = window.document.getElementById('kubra-custom-app');
    const appWidth = (appDOMContainer && appDOMContainer.offsetWidth) || window.innerWidth;
    const breakpoint = getNameByPixels(appWidth);

    if (breakpoint) {
      setDeviceType(breakpoint);
    }
  }, 10);

  useEffect((): () => void => {
    window.addEventListener('resize', onResize);
    onResize();
    return (): void => {
      window.removeEventListener('resize', onResize);
    };
  });

  if (bgeReport && bgeReport.custRestored.stormMode) { document.title = 'BGE Customers Restored Report'; }

  return (
    <div id={'kubra-custom-app'} className='app'>
      {sc5ReportStatus === GET_REPORT_FAILURE && sc5ApiError !== undefined && <h1>{sc5ApiError}</h1>}
      {sc5ReportStatus === GET_REPORT_FAILURE && sc5ApiError === undefined && <h1>There was an unknown error</h1>}
      {sc5ReportStatus === GET_REPORT_REQUEST && <LoadingScreen/>}
      {sc5ReportStatus === GET_REPORT_SUCCESS && sc5Report !== undefined
        && bgeReport !== undefined
        && <div>
          {bgeReport.custRestored.stormMode ? <TitleBar deviceType={deviceType} title={'Customers Restored Report'}/> : <TitleBar deviceType={deviceType}/>}
          {bgeReport.custRestored.stormMode ? <ReportPanel sc5Report={sc5Report} deviceType={deviceType} custRReport={bgeReport.custRestored}/> : <InfoPanel deviceType={deviceType}/>}
        </div>}
    </div>
  );
};

export default App;
